import { render, staticRenderFns } from "./QuaggaWrapper.vue?vue&type=template&id=4d763fdf&"
import script from "./QuaggaWrapper.ts?vue&type=script&lang=ts&"
export * from "./QuaggaWrapper.ts?vue&type=script&lang=ts&"
import style0 from "./QuaggaWrapper.vue?vue&type=style&index=0&id=4d763fdf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports